module.exports = __webpack_public_path__ + "img/magni.2ee55f3b.svg";